import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_ORIGIN_CATEGORY](state, payload) {
    state.originsCategories = payload;
  },
  [MutationsType.SET_ORIGINS_CATEGORIES](state, payload) {
    state.originsCategories = payload;
  },
  [MutationsType.ADD_ORIGIN_CATEGORY](state, payload) {
    if (state.originsCategories) state.originsCategories.unshift(payload);
  },
  [MutationsType.UPDATE_ORIGIN_CATEGORY](state, payload) {
    let ind = state.originsCategories?.findIndex((originCategory) => originCategory.id === payload.id);
    if (ind >= 0) Vue.set(state.originsCategories, ind, { ...state.originsCategories[ind], ...payload });
    if (state.originCategory && payload.id === state.originCategory.id) {
      state.originCategory = { ...state.originCategory, ...payload };
    }
  },
  [MutationsType.RESET_ORIGINS_CATEGORIES](state) {
    state.originsCategories = null;
  },
};
